import { render } from "./kumo4.vue?vue&type=template&id=61cfe9d8&scoped=true"
import script from "./kumo4.vue?vue&type=script&lang=js"
export * from "./kumo4.vue?vue&type=script&lang=js"

import "./kumo4.vue?vue&type=style&index=0&id=61cfe9d8&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cfe9d8"]])

export default __exports__